<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('title.inventoryLock')" type="confirm" width="25%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{ span: 6 }" :model="result" :wrapper-col="{ span: 18 }">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.availableLockedQuantity')">
            <vxe-number-input v-model="result.availableLockingQuantity" disabled style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.lockedQuantity')">
            <vxe-number-input v-model="result.lockedQuantity" :max="result.availableLockingQuantity" :min="1" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.lockReasons')">
            <vxe-textarea v-model="result.reasons" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { post } from '@/api/Api'
import api from '@/api'

export default {
  name: 'InventoryLockConfirmModal',
  data() {
    return {
      visible: false,
      loading: false,
      value: '',
      record: undefined,
      result: {
        reasons: null,
        lockedQuantity: null,
        availableLockingQuantity: null
      }
    }
  },
  methods: {
    open(record) {
      this.record = record
      this.result.lockedQuantity = record.inventory.availableOutboundQuantity
      this.result.availableLockingQuantity = record.inventory.availableOutboundQuantity
      this.visible = true
    },
    confirm() {
      this.loading = true
      const args = { inventory: { id: this.record.inventory.id, availableOutboundQuantity: this.result.lockedQuantity }, reasons: this.result.reasons, 'log.id': null, locking: true }
      post(api.save, { type: 'inventoryLogPersister' }, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>